import { Routes, Route } from 'react-router-dom';
import CampaignLanding from './pages/CampaignLanding';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<CampaignLanding />} />
      <Route path="*" element={<CampaignLanding />} />
    </Routes>
  );
}
